module.exports = __webpack_public_path__ + "img/PtownFlags_05.8c80af08.png";